import { render } from "./CustomersToolbar.vue?vue&type=template&id=82115906&scoped=true"
import script from "./CustomersToolbar.vue?vue&type=script&lang=js"
export * from "./CustomersToolbar.vue?vue&type=script&lang=js"

import "./CustomersToolbar.vue?vue&type=style&index=0&id=82115906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82115906"]])

export default __exports__